// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-item {
  text-align: center;
  cursor: pointer;
}

.nav-card {
  padding: 10px;
  border-radius: 10px;
  transition: transform 0.2s ease;
}

.nav-card:hover {
  transform: scale(1.05);
  background-color: #f8f9fa;
}

.nav-icon {
  font-size: 24px;
  margin-bottom: 5px;
}

.nav-label {
  font-size: 14px;
  font-weight: 500;
}
.nav-item {
  text-align: center;
  cursor: pointer;
}

.nav-card {
  padding: 10px;
  border-radius: 8px;
  transition: transform 0.2s ease;
}

.active-step .nav-card {
  background-color: #007bff;
  color: #fff;
  transform: scale(1.05);
}

.nav-card:hover {
  background-color: #e2e6ea;
}

.nav-icon {
  font-size: 24px;
  margin-bottom: 5px;
}

.nav-label {
  font-size: 14px;
  font-weight: 500;
}

.navigation-buttons {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
.highcharts-credits {
  display: none;
  color: red;
}
`, "",{"version":3,"sources":["webpack://./src/Sidebar/Chart/Charts.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,UAAU;AACZ","sourcesContent":[".nav-item {\r\n  text-align: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.nav-card {\r\n  padding: 10px;\r\n  border-radius: 10px;\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.nav-card:hover {\r\n  transform: scale(1.05);\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n.nav-icon {\r\n  font-size: 24px;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.nav-label {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n}\r\n.nav-item {\r\n  text-align: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.nav-card {\r\n  padding: 10px;\r\n  border-radius: 8px;\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.active-step .nav-card {\r\n  background-color: #007bff;\r\n  color: #fff;\r\n  transform: scale(1.05);\r\n}\r\n\r\n.nav-card:hover {\r\n  background-color: #e2e6ea;\r\n}\r\n\r\n.nav-icon {\r\n  font-size: 24px;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.nav-label {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n}\r\n\r\n.navigation-buttons {\r\n  margin-top: 20px;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n.highcharts-credits {\r\n  display: none;\r\n  color: red;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
